import React, { useEffect } from "react";
//---------- FONTAWESOME IMPORT ------------//
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
import {
    faCircle,
    faEllipsisVertical,
    faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
    Button,
    Card,
    Col,
    Container,
    Dropdown,
    Form,
    Image,
    Row,
    Table,
} from "react-bootstrap";
import {
    AssignImg,
    Delete_2,
    Edit_2,
    Eye_2,
    Filters,
    Man,
} from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import WithoutImageHeader from "../../../../Helper/withoutImageHeader";
import PaginationComponent from "../../../CommanComponents/Pagination";
import StaffListFunctions from "./function";
import { useState } from "react";
import StaffFilterModal from "../../../Modals/StaffFilterModal";

const StaffList = () => {
    const {
        breadcrumData,
        breadcrumItem,
        handleBreadcrumDataNaviagtion,
        stafList,
        getStafListing,
    } = StaffListFunctions();
    const [staffFilter, setStaffFilter] = useState(false);
    const { navigate } = StaffListFunctions();

    useEffect(() => {
        getStafListing();
    }, []);

    console.log(stafList && stafList, "--------------Stafflist-----------");

    return (
        <div className="task_list_screen staff_list_section">
            <WithoutImageHeader
                header={Constants.STAFF_LIST}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
                handleBreadcrumDataNaviagtion={(i) =>
                    handleBreadcrumDataNaviagtion(i)
                }
                lefticon="menu"
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="task_list_details">
                            <div className="title_btn_area">
                                <div className="left_area">
                                    <p>Total Staff: 0</p>
                                </div>
                                <div className="right_area">
                                    <Button
                                        className="btn"
                                        type="submit"
                                        onClick={() => navigate("/add-staff")}
                                    >
                                        Add Staff
                                    </Button>
                                </div>
                            </div>
                            <div className="search_section">
                                <div className="search_area">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search"
                                                // value={searchInput}
                                                // onChange={handleChange}
                                            />
                                            <a href="javascript:;">
                                                <div className="icon">
                                                    <FontAwesomeIcon
                                                        icon={faSearch}
                                                    />
                                                </div>
                                            </a>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="pagination_list">
                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Select>
                                                <option>5</option>
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Form>
                                </div>

                                <div className="filter_button">
                                    <Button
                                        className="btn-primary btn-border"
                                        onClick={() => setStaffFilter(true)}
                                    >
                                        <Image
                                            src={Filters}
                                            alt="..."
                                            className="image_area"
                                        />
                                        Filters
                                    </Button>
                                    <FontAwesomeIcon
                                        icon={faCircle}
                                        className="filter_icon"
                                    />
                                </div>
                            </div>

                            {stafList && stafList.length > 0 ? (
                                <div className="staff_table_area">
                                    <div className="table-responsive">
                                        <Table responsive>
                                            <tr>
                                                <th>Name</th>
                                                <th>Role</th>
                                                <th>Department</th>
                                                <th>Hospital Name</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                            {stafList &&
                                                stafList.map((item, index) => (
                                                    <tr className="active">
                                                        <td>
                                                            <div className="profile_area">
                                                                <div className="left_area">
                                                                    <div className="img_area">
                                                                        <Image
                                                                            src={
                                                                                Man
                                                                            }
                                                                            alt="..."
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="right_area">
                                                                    <a href="javascript:;">
                                                                        {
                                                                            item.name
                                                                        }
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="text_box">
                                                                {
                                                                    item.role_title
                                                                }
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="text_box">
                                                                {
                                                                    item.department_title
                                                                }
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <p>
                                                                Oxford Hospital
                                                            </p>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className={
                                                                    parseInt(
                                                                        item.status
                                                                    ) === 1
                                                                        ? "active"
                                                                        : "deactive"
                                                                }
                                                            >
                                                                {parseInt(
                                                                    item.status
                                                                ) === 1
                                                                    ? "Active"
                                                                    : "Deactivate"}
                                                            </div>
                                                            {/* <div className="active">
                                                    Active
                                                </div> */}
                                                        </td>
                                                        <td>
                                                            <div className="icon">
                                                                <Dropdown>
                                                                    <Dropdown.Toggle
                                                                        variant="none"
                                                                        id="dropdown-basic"
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faEllipsisVertical
                                                                            }
                                                                            className="ellipsis_icon"
                                                                        />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item href="javascript:;">
                                                                            View{" "}
                                                                            <Image
                                                                                src={
                                                                                    Eye_2
                                                                                }
                                                                                alt="..."
                                                                                className="image_area"
                                                                            />
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Item href="javascript:;">
                                                                            Edit
                                                                            <Image
                                                                                src={
                                                                                    Edit_2
                                                                                }
                                                                                alt="..."
                                                                                className="image_area"
                                                                            />
                                                                        </Dropdown.Item>
                                                                        <Dropdown.Item href="javascript:;">
                                                                            Delete
                                                                            <Image
                                                                                src={
                                                                                    Delete_2
                                                                                }
                                                                                alt="..."
                                                                                className="image_area delete_icon "
                                                                            />
                                                                        </Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </Table>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </Container>
            <PaginationComponent />
            <StaffFilterModal
                show={staffFilter}
                onClose={() => setStaffFilter(false)}
            />
        </div>
    );
};

export default StaffList;
